export const isValidDateString = (dateStr: string) => !isNaN(Date.parse(dateStr));
